import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    id: z.string().optional(),
    name: z
      .string({ required_error: 'Tag name is required' })
      .min(1, 'Tag name is required'),
    color: z
      .string({ required_error: 'Color is required' })
      .min(1, 'Color is required'),
  })

export type ClientTagModel = z.infer<ReturnType<typeof schema>>

export const useClientTagForm = () => {
  const clientTagTypeSchema = schema()
  const { form, rule } = useFormWithZod(clientTagTypeSchema)
  return { form, rule, schema: clientTagTypeSchema }
}
